var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bo-cell-user username"},[(_vm.value.image)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.value.image}}):(_vm.value.name)?_c('div',{staticClass:"initials avatar"},[_vm._v("\n        "+_vm._s(_vm.userInitial(_vm.value.name))+"\n    ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.value.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }